import { api } from './client';
import type {
  CategoryFacet,
  GroupedServices,
  ServiceCategory,
  ServiceDetail,
  ServiceListPage,
  ServiceSummary,
  SubCategoriesByCategory,
} from '../types/api';

export interface ListServicesParams {
  q?: string;
  category?: ServiceCategory;
  authorityId?: string;
  pincode?: string;
  page?: number;
  pageSize?: number;
  includeInactive?: boolean;
}

export async function listServices(params: ListServicesParams = {}): Promise<ServiceListPage> {
  const { data } = await api.get<ServiceListPage>('/services', { params });
  return data;
}

export async function listAllServices(params: ListServicesParams = {}): Promise<ServiceSummary[]> {
  const pageSize = 2000;
  const mergedParams: ListServicesParams = { ...params, pageSize };

  const first = await listServices(mergedParams);
  if (first.totalPages <= 1) return first.items;
  const rest = await Promise.all(
    Array.from({ length: first.totalPages - 1 }, (_, i) =>
      listServices({ ...mergedParams, page: i + 2 }),
    ),
  );
  return [first, ...rest].flatMap((p) => p.items);
}

export async function listCategories(): Promise<CategoryFacet[]> {
  const { data } = await api.get<{ items: CategoryFacet[] }>('/services/categories');
  return data.items;
}

export async function listGroupedServices(): Promise<GroupedServices> {
  const { data } = await api.get<GroupedServices>('/services/grouped');
  return data;
}

export async function listSubCategoriesByCategory(): Promise<SubCategoriesByCategory> {
  const { data } = await api.get<SubCategoriesByCategory>('/services/sub-categories');
  return data;
}

export async function getService(id: string): Promise<ServiceDetail> {
  const { data } = await api.get<ServiceDetail>(`/services/${id}`);
  return data;
}

export async function getStates(): Promise<string[]> {
  const { data } = await api.get<string[]>('/pincodes/states');
  return data;
}

export async function getDistricts(state: string): Promise<string[]> {
  const { data } = await api.get<string[]>('/pincodes/districts', {
    params: { state },
  });
  return data;
}

export async function getTaluks(district: string): Promise<string[]> {
  const { data } = await api.get<string[]>('/pincodes/taluks', {
    params: { district },
  });
  return data;
}
